import LogToken from './pages/logtoken/LogToken';
import Login from './pages/login/Login';
import SignUp from './pages/signup/SignUp';
import ForgotPassword from './pages/passwordReset/ForgotPassword';
import Categories from './pages/learning/categories/Categories';
import Materials from './pages/learning/materials/Materials';
import Material from './pages/learning/material/Material';
import Tests from './pages/tests/Tests';
import Test from './pages/test/Test';
import Profile from './pages/profile/Profile';
import NewTest from './pages/admin/NewTest';
import NewMaterial from './pages/admin/NewMaterial';
import AdminMaterials from './pages/admin/materials/Materials';
import AdminUsers from './pages/admin/Users';
import AdminDashboard from './pages/admin/dashboard/Dashboard';
import AdminCategories from './pages/admin/Categories';
import ReportEmployees from './pages/admin/reports/ReportEmployees';
import ReportSellers from './pages/admin/reports/ReportSellers';
import Specials from './pages/admin/specials/Specials';
import ResetPassword from "./pages/passwordReset/ResetPassword";
import States from './pages/admin/States';
import UnsubscribePage from './pages/UnsubscribePage';
import MonthlyTests from './pages/monthly-test/MonthlyTests';
import AdminMonthlyTests from './pages/admin/monthly-test/MonthlyTests';

export const mainMenuItems = [
  { to: '/learning/categories', label: 'Материалы' },
  { to: '/learning/materials', label: 'На изучении' },
  { to: '/monthly-tests', label: 'Ежемесячное тестирование', roles: [1, 3, 4, 5, 6, 9, 10, 11, 12] },
];

type AdminMenuItem = {
  to: string;
  label: string;
  roles: number[];
  permissions?: string[];
};

type PermissionsMap = { [key: string]: boolean };

export const getAdminMenuItems = (
  role: number,
  isAdmin: boolean,
  permissions: PermissionsMap,
  type: string,
): AdminMenuItem[] => {
  const adminMenu: AdminMenuItem[] = [
    { roles: [], to: '/admin/dashboard', label: 'Статистика' },
    { roles: [], to: '/admin/materials', label: 'Материалы', permissions: ['customCategoriesMaterialsTests', 'editUsersAccess'] },
    { roles: [], to: '/admin/categories', label: 'Категории', permissions: ['customCategoriesMaterialsTests'] },
    { roles: [], to: '/admin/users', label: 'Пользователи', permissions: ['editUserStatus'] },
    { roles: [], to: '/admin/states', label: 'Филиалы' },
    { roles: [3, 4], to: '/admin/specials', label: 'Действующие акции' },
    { roles: [2, 3, 4], to: '/admin/reports/employees', label: 'Отчет', permissions: ['editUsersAccess', 'customCategoriesMaterialsTests', 'editUserStatus'] },
    { roles: [2, 3, 4], to: '/admin/reports/sellers', label: 'Отчет по продавцам', permissions: ['editUsersAccess', 'customCategoriesMaterialsTests', 'editUserStatus'] },
    { roles: [], to: '/admin/monthly-tests', label: 'Ежемесячное тестирование' },
  ];

  if (isAdmin && !role && type !== 'registered') return adminMenu;

  return adminMenu.filter(item => {
    const hasRole = item.roles.includes(role);
    const hasPermission = item.permissions && permissions ? item.permissions.some(perm => permissions[perm]) : false;
    return hasRole || hasPermission;
  });
};

export const routeAuthItems = (): any => {
  return [
    { type: 'user', path: '/login', element: <Login /> },
    { type: 'user', path: '/logtoken', element: <LogToken /> },
    { type: 'user', path: '/signup', element: <SignUp /> },
    { type: 'user', path: '/forgot-password', element: <ForgotPassword /> },
    { type: 'user', path: '/reset-password/:resetToken', element: <ResetPassword /> },
    { type: 'user', path: '/email/unsubscribe/:token', element: <UnsubscribePage /> },
  ]
}

export const routeItems = (user: any): any => {
  const isAccessToUserPart = (!user.isAdmin && user.type === 'lp') || user.accessUserPart || user.type === 'admin';
  const { role, type, isAdmin, extraData } = user;
  const permissions = extraData?.permissions || {};

  const hasAccess = (item: any) => {
    if (item.type === 'user') return true;
    if (item.type === 'admin') {
      if (isAdmin && type !== 'registered') return true;
      
      const hasRole = item.roles?.includes(role) || false;
      const hasPermission = item.permissions ? item.permissions.some((perm: string) => permissions[perm]) : false;
      
      return hasRole || hasPermission;
    }
    return true;
  };

  return [
    { type: 'user', path: '/', element: <Categories /> },
    { type: 'user', path: '/logtoken', element: <LogToken /> },
    { type: 'user', path: '/learning/categories', element: <Categories /> },
    { type: 'user', path: '/learning/categories/:id', element: <Categories /> },
    { type: 'user', path: '/learning/materials/:id', element: <Materials isLearning={0} /> },
    { type: 'user', path: '/learning/materials', element: <Materials isLearning={1} /> },
    { type: 'user', path: '/learning/material/:id', element: <Material /> },
    { type: 'user', path: '/tests', element: <Tests /> },
    { type: 'user', path: '/test/:id', element: <Test /> },
    { type: 'user', path: '/monthly-tests', element: <MonthlyTests /> },
    { type: 'user', path: '/monthly-test/:id', element: <Test testType="monthly" /> },
    { type: 'both', path: '/profile', element: <Profile /> },
    { type: 'admin', path: '/admin/new-test/:id', element: <NewTest />, permissions: ['customCategoriesMaterialsTests', 'editUsersAccess'] },
    { type: 'admin', path: '/admin/new-material', element: <NewMaterial />, permissions: ['customCategoriesMaterialsTests', 'editUsersAccess'] },
    { type: 'admin', path: '/admin/new-material/:id', element: <NewMaterial />, permissions: ['customCategoriesMaterialsTests', 'editUsersAccess']  },
    { type: 'admin', path: '/admin/materials', element: <AdminMaterials />, permissions: ['customCategoriesMaterialsTests', 'editUsersAccess'] },
    { type: 'admin', path: '/admin/materials/:id', element: <AdminMaterials />, permissions: ['customCategoriesMaterialsTests', 'editUsersAccess'] },
    { type: 'admin', path: '/admin/users', element: <AdminUsers />, permissions: ['editUserStatus'] },
    { type: 'admin', path: '/admin/states', element: <States /> },
    { type: 'admin', path: '/admin/dashboard', element: <AdminDashboard /> },
    { type: 'admin', path: '/admin/categories', element: <AdminCategories />, permissions: ['customCategoriesMaterialsTests'] },
    { type: 'admin', path: '/admin/reports/sellers', element: <ReportSellers mode="sellers" />, roles: [2, 3, 4], permissions: ['editUsersAccess', 'customCategoriesMaterialsTests', 'editUserStatus'] },
    { type: 'admin', path: '/admin/reports/employees', element: <ReportEmployees mode="employee" />, roles: [2, 3, 4], permissions: ['editUsersAccess', 'customCategoriesMaterialsTests', 'editUserStatus'] },
    { type: 'admin', path: '/admin/specials', element: <Specials />, roles: [3, 4] },
    { type: 'admin', path: '/admin/monthly-tests', element: <AdminMonthlyTests /> },
    { type: 'user', path: '/email/unsubscribe/:token', element: <UnsubscribePage /> },
  ].map(x => {
    if (x.type === 'user' && !isAccessToUserPart) {
      return { ...x, element: <h2>Доступ закрыт, обратитесь в техподдержку.</h2> };
    }
    if (x.type === 'admin' && !hasAccess(x)) {
      return { ...x, element: <h2>Доступ закрыт, обратитесь в техподдержку.</h2> };
    }
    return x;
  });
};